(function ($) {
	$(window).load(function () {
		if (typeof dataLayer == "undefined") {
			return;
		}

		if ($(".transfer.item").length) {
			var transfer_item = $(".transfer.item").first();
			var vehicle_price = transfer_item.find(".rate_price").data("price");
			var pickup = getPointNameFromID(getQueryVariable("transfer_pickup_location"));
			var dropoff = getPointNameFromID(getQueryVariable("transfer_dropoff_location"));
			var transfer_type = transfer_item.find('input[name="roundtrip"]').val() == "false" ? "oneway" : "roundtrip";
			var quantity = transfer_item.find('input[name="VehicleQuantity"]').val();
			var product = {
				name: pickup + " - " + dropoff,
				id: slugify(pickup + " - " + dropoff),
				variant: transfer_type,
				category: "transfers",
				price: parseFloat(vehicle_price / quantity),
				quantity: quantity,
				list: "Transfer Search Results",
				position: 1,
			};
			createImpressionsTag(product, product.list);

			$(".transfer.item .submit").on("click", function (event) {
				var vehicle_price = $(this).siblings(".rate_price").data("price");
				var transfer_type = $(this).parent(".item-availability").siblings('input[name="roundtrip"]').val() == "false" ? "oneway" : "roundtrip";
				var quantity = $(this).parent(".item-availability").siblings('input[name="VehicleQuantity"]').val();
				var products = [];
				products.push({
					name: pickup + " - " + dropoff,
					id: slugify(pickup + " - " + dropoff),
					variant: transfer_type,
					category: "transfers",
					price: parseFloat(vehicle_price / quantity),
					quantity: quantity,
				});
				createAddToCartTag(products, "Transfer Search Results");
			});
		}

		if ($(".excursion.item").length) {
			var excursion_item = $(".excursion.item").first();
			var price = excursion_item.find(".item-price").first().data("price");
			var name = excursion_item.find(".item-title").first().text();
			var product = {
				name: name,
				id: slugify(name),
				variant: "excursion",
				category: "excursions",
				price: price,
				quantity: 1,
				list: "Excursion Search Results",
				position: 1,
			};
			createImpressionsTag(product, product.list);

			$(".excursion.item .excursion-day.available").on("click", function (event) {
				var excursion_item = $(this).closest(".excursion.item");
				var name = excursion_item.find(".item-title").first().text();
				var price = excursion_item.find(".item-price").first().data("price");
				var products = [];
				products.push({
					name: name,
					id: slugify(name),
					variant: "excursion",
					category: "excursions",
					price: price,
					quantity: 1,
				});
				createAddToCartTag(products, "Excursion Search Results");
			});
		}

		if ($(".hotelitems > .item").length) {
			var hotel_item = $(".hotelitems > .item").first();
			var price = hotel_item.find(".item-price").first().data("rate-price");
			var name = hotel_item.find(".item-title").first().text();
			var product = {
				name: name,
				id: slugify(name),
				variant: "hotel",
				category: "hotels",
				price: price,
				quantity: 1,
				list: "Hotel Search Results",
				position: 1,
			};
			createImpressionsTag(product, product.list);

			$(".hotelitems > .item a.submit").on("click", function (event) {
				var hotel_item = $(this).closest(".item");
				var price = hotel_item.find(".item-price").first().data("rate-price");
				var name = hotel_item.find(".item-title").first().text();
				var products = [];
				products.push({
					name: name,
					id: slugify(name),
					variant: "hotel",
					category: "hotels",
					price: price,
					quantity: 1,
				});
				createAddToCartTag(products, "Hotel Search Results");
			});
		}

		if ($(".rentalitems > .rental.item").length) {
			var rental_item = $(".rentalitems > .rental.item").first();
			var price = rental_item.find(".rate_price").first().data("price");
			var name = rental_item.find(".vehicle_title").first().data("title");
			var product = {
				name: name,
				id: slugify(name),
				variant: "rental",
				category: "rentals",
				price: price,
				quantity: 1,
				list: "Rental Search Results",
				position: 1,
			};
			createImpressionsTag(product, product.list);

			$(".rentalitems > .rental.item a.submit.book-now").on("click", function (event) {
				var rental_item = $(this).closest(".rental.item");
				var price = rental_item.find(".rate_price").first().data("price");
				var name = rental_item.find(".vehicle_title").first().data("title");
				var products = [];
				products.push({
					name: name,
					id: slugify(name),
					variant: "rental",
					category: "rentals",
					price: price,
					quantity: 1,
				});
				createAddToCartTag(products, "Rental Search Results");
			});
		}

		if ($(".payment-success.reservation").length && typeof tags !== "undefined" && tags != null) {
			var reservation_reference = $(".reservation-reference").data("reference");
			var products = [];
			products.push({
				name: tags["name"],
				id: slugify(tags["name"]),
				variant: tags["variant"],
				category: tags["category"],
				price: tags["price"],
				quantity: tags["quantity"],
			});
			createCompletedTransactionTag(products, reservation_reference, tags["price"]);
		}
	});
})(jQuery);

window.checkoutTag = function checkoutTag(payment_option) {
	if (typeof tags == "undefined") {
		return;
	}
	var products = [];
	products.push({
		name: tags["name"],
		id: slugify(tags["name"]),
		variant: tags["variant"],
		category: tags["category"],
		price: tags["price"],
		quantity: tags["quantity"],
	});
	createCheckoutTag(products, payment_option);
}

function createImpressionsTag(product, listName) {
	window.dataLayer.push({
		event: "impressions",
		ecommerce: {
			currencyCode: "EUR",
			impressions: [product],
			detail: {
				actionField: {
					list: listName,
				},
				products: [
					{
						name: product.name,
						id: slugify(product.name),
						price: product.price,
						category: product.category,
						variant: product.variant,
					},
				],
			},
		},
	});
	// GA4
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: "view_item_list",
		ecommerce: {
			items: [
				{
					item_name: product.name,
					item_id: slugify(product.name),
					price: product.price,
					item_category: product.category,
					item_variant: product.variant,
					item_list_name: listName,
					item_list_id: slugify(listName),
					index: 1,
					quantity: 1
				}]
		}
	});
}

function createAddToCartTag(products, listName) {
	window.dataLayer.push({
		event: "addToCart",
		ecommerce: {
			currencyCode: "EUR",
			add: {
				actionField: {
					list: listName,
				},
				products: products,
			},
		},
	});
	// GA4
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: "add_to_cart",
		ecommerce: {
			items: [{
				item_name: products[0].name,
				item_id: slugify(products[0].name),
				price: products[0].price,
				item_category: products[0].category,
				item_variant: products[0].variant,
				item_list_name: listName,
				item_list_id: slugify(listName),
				index: 1,
				quantity: products[0].quantity
			}]
		}
	});
}

function createCheckoutTag(products, payment_option) {
	window.dataLayer.push({
		event: "checkout",
		ecommerce: {
			checkout: {
				actionField: {
					list: window.tags.list,
					step: 1,
					option: payment_option,
				},
				products: products,
			},
		},
	});
	// GA4
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: "begin_checkout",
		ecommerce: {
			items: [{
				item_name: products[0].name,
				item_id: slugify(products[0].name),
				price: products[0].price,
				item_category: products[0].category,
				item_variant: products[0].variant,
				index: 1,
				item_list_name: window.tags.list,
				item_list_id: slugify(window.tags.list),
				quantity: products[0].quantity
			}]
		}
	});
}

function createCompletedTransactionTag(products, reservation_reference, price) {
	window.dataLayer.push({
		event: "CompletedTransaction",
		ecommerce: {
			purchase: {
				actionField: {
					id: reservation_reference,
					affiliation: "Kos4all.com",
					revenue: price, // Total transaction value (incl. tax and shipping)
				},
				products: products,
			},
		},
	});
	// GA4
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: "purchase",
		ecommerce: {
			transaction_id: reservation_reference,
			affiliation: "Kos4all.com",
			value: price,
			tax: (parseFloat(price) * 0.17).toFixed(2),
			shipping: "0",
			currency: "EUR",
			coupon: "UNDEFINED",
			items: [{
				item_name: products[0].name,
				item_id: slugify(products[0].name),
				price: products[0].price,
				item_category: products[0].category,
				item_variant: products[0].variant,
				quantity: products[0].quantity
			}]
		}
	});
	window.dataLayer.push({
		event: "ec_formsubmit",
		enhanced_conversion_data: {
			"email": window.conversion.email
		}
	})
}

const slugify = (text) =>
	text
		.toString()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.trim()
		.replace(/\s+/g, "-")
		.replace(/[^\w-]+/g, "")
		.replace(/--+/g, "-");

function getPointNameFromID(id) {
	if (typeof window.PickupDropoffPoints !== 'undefined') {
		for (let index = 0; index < Object.getOwnPropertyNames(window.PickupDropoffPoints).length; index++) {
			const type = Object.getOwnPropertyNames(window.PickupDropoffPoints)[index];
			for (let index = 0; index < window.PickupDropoffPoints[type].length; index++) {
				const element = window.PickupDropoffPoints[type][index];
				if (element.ID == id) {
					return element.Name;
				}
			}
		}
	}
	return false;
}